import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../config/api";

export const createSubscription = createAsyncThunk(
  'subscription/create', 
  async (data) => {
    const response = await api.post('/subscriptions', data);
    return response.data;
  }
);

export const getSpecificUserPaymentHistory = createAsyncThunk('subscription/paymentHistory', async () => {
  const response = await api.get('/subscriptions/my-payments');
  return response.data;
});

export const updateSubscription = createAsyncThunk('subscription/updateSubscription',
  async (data) => {
    const response = await api.post('/subscriptions/update-subscription', data);
    return response.data;
  }
);

export const scheduleUpgradeSubscription = createAsyncThunk('subscription/scheduleUpgradeSubscription',
  async (data) => {
    const response = await api.post('/subscriptions/scheduled-upgrade', data);
    return response.data;
  }
);

export const cancelSubscription = createAsyncThunk('subscription/cancelSubscription', async (data) => {
  const response = await api.post('/subscriptions/cancel-subscription', data);
  return response.data;
});

export const getScheduledUpgrade = createAsyncThunk('subscription/getScheduledUpgrade', async () => {
  const response = await api.get('/subscriptions/scheduled-upgrade');
  console.log("response.data", response)
  return response.data;
});

export const checkEligibility = createAsyncThunk('auth/checkEligibility', async (data) => {
  const response = await api.post('/auth/check-eligibility', data);
  return response.data;
});